class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay')) || 0;
        this.repeatHours = parseInt(this.popup.getAttribute('data-repeat-hours')) || 2;

        this.storageKey = 'zaragul_newsletter_closed_time';
        this.repeatTime = this.repeatHours * 60 * 60 * 1000;

        const now = Date.now();
        const lastClosed = localStorage.getItem(this.storageKey);

        // ✅ Only show if allowed
        if (this.shouldShow(now, lastClosed)) {

            setTimeout(() => {
                document.body.classList.add('newsletter-show');

                setTimeout(() => {
                    document.body.classList.add('show-newsletter-image');
                }, 700);

            }, this.timeToShow);
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        const closeBtn = this.querySelector('[data-close-newsletter-popup]');
        if (closeBtn) {
            closeBtn.addEventListener('click', this.closePopup.bind(this));
        }

        const form = this.querySelector('#ContactPopup');
        if (form) {
            form.addEventListener('submit', this.closePopup.bind(this));
        }
    }

    shouldShow(now, lastClosed) {
        if (!lastClosed) return true;

        const timePassed = now - parseInt(lastClosed);
        return timePassed >= this.repeatTime;
    }

    closePopup() {
        // ✅ Save close time
        localStorage.setItem(this.storageKey, Date.now());

        document.body.classList.remove('newsletter-show');

        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);
    }

    onBodyClickEvent(event) {
        if (
            !this.contains(event.target) &&
            !event.target.closest('[data-open-newsletter-popup]') &&
            document.body.classList.contains('newsletter-show')
        ) {
            this.closePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);
